import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy Student Progress redirect
 *
 * Route: /:locale/student/progress
 * Personal Flow is the canonical student progress destination.
 */
export function redirectStudentProgress(locale: string): never {
  // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router redirect pattern
  throw redirect({
    to: '/$locale/student/personal-flow',
    params: { locale },
    search: { tab: 'in-progress' },
    replace: true,
  });
}

export const Route = createFileRoute('/$locale/_authenticated/student/progress')({
  beforeLoad: ({ params }) => redirectStudentProgress(params.locale),
  component: () => null,
});
